  if(!customElements.get('product-nonsubscription')) {
    class ProductNonSubscription extends HTMLElement {
      constructor() {
        super();
        this.mainElement = this.closest('.product-main-element');
        this.oneTimeWrapper = this.mainElement.querySelector('.one-time-wrapper');
        this.option = this.oneTimeWrapper.querySelector('.option');
        this.oneTimePrice = this.mainElement.querySelector('.option .option-price');
        this.productHiddenId = this.mainElement.querySelector('[data-variant-id]');
        this.caseQuantity = this.mainElement.querySelector('#case_quantity');
        this.caseCta = this.mainElement.querySelector('.case-cta');
        this.caseInfo = this.caseCta.querySelector('.info .quantity');
        this.caseFormat = this.caseCta.querySelector('.info .format');
        this.caseSize = this.caseInfo.textContent || 4;
        this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
        this.variantId = this.productHiddenId.value;
        
        this.caseQuantity.addEventListener('change', this.onChangeCases.bind(this));
        this.updateVariant();
      }

      onVariantChange(e) {
        this.updateVariant();
      }

      updateVariant() {
        var variant = this.mainElement.getCurrentVariant();
        this.variantId = variant.id;
        this.option.dataset.price = variant.price;
        this.updatePrices();

        this.caseFormat.innerHTML = this.mainElement.productData.productFormatQuantity[this.variantId].format;
        this.caseSize = this.mainElement.productData.productFormatQuantity[this.variantId].quantity;
        this.onChangeCases();
      }

      updatePrices() {
        this.oneTimePrice.textContent = $s.formatMoney(this.option.dataset.price * this.caseQuantity.value).replace('.00', '');
      }

      onChangeCases(e) {
        this.caseInfo.textContent = this.caseQuantity.value * this.caseSize;
        this.updatePrices();
      }
    }
    customElements.define('product-nonsubscription', ProductNonSubscription);
  }